<template lang="pug">
awesome(:icon="[getType, getIcon]" v-if="visible")
i.icon(:class="[getType, getIcon]" v-else)
</template>

<script>
import Vue from "vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
Vue.component("awesome", FontAwesomeIcon)
export default {
  name: "icon",
  props: {
    type: {
      type: String,
      default: "fa-icon"
    },
    icon: {
      type: String,
      default: ""
    },
    spinner: Boolean
  },
  computed: {
    getType() {
      if (this.type === "flat-icon") return "fi"

      const array = this.icon.split(" ")
      return array.length > 1 ? array[0] : "fal"
    },
    getIcon() {
      if (this.type === "flat-icon") return this.icon

      const array = this.icon.split(" ")
      let icon = array.length > 1 ? array[1] : array[0]
      return this.visible ? "" + icon : "fa-" + icon
    },
    visible() {
      return false
    }
  }
}
</script>
